import { render, staticRenderFns } from "./questionBank_info.vue?vue&type=template&id=7c2f4424&scoped=true"
import script from "./questionBank_info.vue?vue&type=script&lang=js"
export * from "./questionBank_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2f4424",
  null
  
)

export default component.exports